import React, { useCallback, useEffect, useState } from "react";
import api from "../../setupAxios";
import { useDialog } from "../../context/dialogContext";
import FiltrosAlumnos from "../FiltrosAlumnos";
import EntradasModal from "./EntradasModal";
import { estadoCita, fechaES, fechaHoraES, fechaLarga, msgError, useListado } from "../../utils";

// Pone o cambia la cita de un alumno: a una franja (aunque esté llena, si se fuerza) o a una hora libre.
function AsignarCita({ alumno, cerrar, alGuardar }) {
  const { avisar, exito } = useDialog();
  const [franjas, setFranjas] = useState([]);
  const [modo, setModo] = useState("franja");
  const [idFranja, setIdFranja] = useState("");
  const [fecha, setFecha] = useState("");
  const [hora, setHora] = useState("");
  const [forzar, setForzar] = useState(false);

  useEffect(() => { api.get("/admin/franjas").then(({ data }) => setFranjas(data.franjas)).catch(() => {}); }, []);
  const sel = franjas.find((f) => String(f.id) === String(idFranja));
  const llena = sel && sel.ocupadas >= sel.aforo;

  const guardar = async () => {
    try {
      const cuerpo = modo === "franja" ? { id_user: alumno.id_user, id_franja: +idFranja, forzar } : { id_user: alumno.id_user, fecha, hora };
      const { data } = await api.post("/admin/citas", cuerpo);
      exito(`Cita puesta: ${fechaES(data.cita.fecha)} ${data.cita.hora}${data.cita.forzada ? " (franja completa, forzada)" : ""}`);
      alGuardar();
    } catch (e) { avisar(msgError(e)); }
  };

  return (
    <div className="modal-back" onMouseDown={cerrar}>
      <div className="modal ci-modal-ancho" onMouseDown={(e) => e.stopPropagation()}>
        <h3>📅 Cita de {alumno.nombre}</h3>
        <p className="muted">Se le mostrará al alumno aunque la franja esté llena o la hora no sea una franja.</p>
        <div className="seg-buttons" style={{ marginBottom: 12 }}>
          <button className={`btn ${modo === "franja" ? "btn-primary" : ""}`} onClick={() => setModo("franja")}>En una franja</button>
          <button className={`btn ${modo === "libre" ? "btn-primary" : ""}`} onClick={() => setModo("libre")}>A una hora libre</button>
        </div>
        {modo === "franja" ? (
          <>
            <div className="field"><label>Franja</label>
              <select value={idFranja} onChange={(e) => setIdFranja(e.target.value)}>
                <option value="">Elige…</option>
                {franjas.map((f) => (
                  <option key={f.id} value={f.id}>{fechaLarga(f.fecha)} · {f.hora_inicio}–{f.hora_fin} · {f.ocupadas}/{f.aforo}{f.ocupadas >= f.aforo ? " COMPLETA" : ""}{f.activa ? "" : " (inactiva)"}</option>
                ))}
              </select></div>
            {llena && (
              <label style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input type="checkbox" style={{ width: "auto" }} checked={forzar} onChange={(e) => setForzar(e.target.checked)} />
                Esta franja está completa: añadirlo igualmente
              </label>
            )}
          </>
        ) : (
          <div className="row">
            <div className="field"><label>Fecha</label><input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} /></div>
            <div className="field"><label>Hora</label><input type="time" value={hora} onChange={(e) => setHora(e.target.value)} /></div>
          </div>
        )}
        <div className="modal-actions">
          <button className="btn" onClick={cerrar}>Cancelar</button>
          <button className="btn btn-primary" onClick={guardar}
                  disabled={modo === "franja" ? !idFranja || (llena && !forzar) : !fecha || !hora}>Guardar cita</button>
        </div>
      </div>
    </div>
  );
}

function Detalle({ alumno, cerrar }) {
  const [d, setD] = useState(null);
  const [hist, setHist] = useState([]);
  useEffect(() => {
    api.get(`/admin/alumno/${alumno.id_user}`).then(({ data }) => setD(data)).catch(() => setD(false));
    api.get("/admin/historial", { params: { id_alumno: alumno.id_user, limite: 100 } }).then(({ data }) => setHist(data.historial)).catch(() => {});
  }, [alumno.id_user]);
  const a = d && d.alumno;
  return (
    <div className="modal-back" onMouseDown={cerrar}>
      <div className="modal ci-modal-ancho" style={{ maxHeight: "90vh", overflowY: "auto" }} onMouseDown={(e) => e.stopPropagation()}>
        <h3>🔍 {alumno.nombre}</h3>
        {d === null && <p className="muted">Cargando…</p>}
        {d === false && <p className="alert alert-error">No se pudo cargar.</p>}
        {a && (
          <>
            <p className="muted" style={{ marginTop: 0 }}>{a.email} · ID cliente {a.id_alumno} · {a.pisos_texto || "sin piso"} · {a.servicio || "—"} · {a.a_r || "—"}</p>
            <p><b>Check-in:</b> {a.id_cita ? `${fechaLarga(a.cita_fecha)} ${a.cita_hora}${a.cita_manual ? " (puesta por admin)" : ""}${a.cita_forzada ? " · franja completa" : ""}` : a.id_fh ? "Fuera de hora" : "sin fecha"}
              {a.llegado ? ` · ✅ llegado ${fechaHoraES(a.llegada_hora)}` : ""}</p>
            {a.id_fh && (
              <div className="ci-aviso-amarillo">Llega el <b>{fechaLarga(a.fh_fecha)}</b>{a.fh_hora ? ` a las ${a.fh_hora}` : ""} en {a.fh_medio} desde {a.fh_origen}.<br />«{a.fh_comentario}»</div>
            )}
            <p><b>Teléfono:</b> {a.telefono_wa || "—"} {a.telefono_origen ? <span className="muted">({a.telefono_origen})</span> : null}</p>
            <h4 style={{ marginBottom: 6 }}>Respuestas</h4>
            {d.respuestas.length === 0 ? <p className="muted">No hay preguntas configuradas.</p> : (
              <ul style={{ paddingLeft: 18, marginTop: 0 }}>
                {d.respuestas.map((r) => <li key={r.id}>{r.texto}{r.activa ? "" : " (desactivada)"}: <b>{r.respuesta || "—"}</b></li>)}
              </ul>
            )}
            {d.texto_libre && <p><b>Texto libre:</b> {d.texto_libre}</p>}
            <h4 style={{ marginBottom: 6 }}>Historial</h4>
            <div className="tablewrap" style={{ maxHeight: 220, overflowY: "auto" }}>
              <table className="t-detalle"><tbody>
                {hist.length === 0 && <tr><td className="empty">Sin movimientos.</td></tr>}
                {hist.map((h) => (
                  <tr key={h.id}><td>{fechaHoraES(h.fecha_hora)}</td><td className="strong">{h.accion}</td><td>{h.actor || "—"}</td><td className="ci-hist-detalle">{h.detalle}</td></tr>
                ))}
              </tbody></table>
            </div>
          </>
        )}
        <div className="modal-actions"><button className="btn btn-primary" onClick={cerrar}>Cerrar</button></div>
      </div>
    </div>
  );
}

export default function TabAlumnos() {
  const { confirmarPeligro, avisar, exito } = useDialog();
  const [f, setF] = useState({});
  const [opciones, setOpciones] = useState({});
  const [resumen, setResumen] = useState(null);
  const [asignar, setAsignar] = useState(null);
  const [detalle, setDetalle] = useState(null);
  const [entradas, setEntradas] = useState(null);
  const { datos, cargando, error, recargar } = useListado("/admin/alumnos", f);

  const cargarResumen = useCallback(() => { api.get("/admin/resumen").then(({ data }) => setResumen(data)).catch(() => {}); }, []);
  useEffect(() => { cargarResumen(); api.get("/admin/opciones").then(({ data }) => setOpciones(data)).catch(() => {}); }, [cargarResumen]);
  const refrescar = () => { recargar(); cargarResumen(); };

  const quitar = async (a) => {
    if (!(await confirmarPeligro(`¿Quitar la cita de ${a.nombre}?`, { titulo: "Quitar cita", boton: "Quitar" }))) return;
    try { await api.delete(`/admin/citas/${a.id_user}`); exito("Cita quitada"); } catch (e) { avisar(msgError(e)); }
    refrescar();
  };

  return (
    <div className="card">
      <div className="card-headrow"><h3>Alumnos <span className="count">{datos.length}</span></h3></div>
      {resumen && (
        <div className="ci-resumen">
          <div className="ci-chip"><b>{resumen.total}</b><span>alumnos</span></div>
          <div className="ci-chip verde"><b>{resumen.con_cita}</b><span>con cita</span></div>
          <div className="ci-chip ambar"><b>{resumen.fuera_de_hora}</b><span>fuera de hora</span></div>
          <div className="ci-chip rojo"><b>{resumen.sin_fecha}</b><span>sin nada</span></div>
          <div className="ci-chip verde"><b>{resumen.llegados}</b><span>han llegado</span></div>
        </div>
      )}
      <FiltrosAlumnos f={f} setF={setF} opciones={opciones} campos={["q", "piso", "servicio", "estado", "acceso", "fecha", "franja", "llegado"]} />
      {error && <div className="alert alert-error">{error}</div>}
      <div className="tablewrap">
        <table className="ci-tabla t-alumnos">
          <thead><tr><th>Alumno</th><th>Piso / hab.</th><th>Entradas</th><th>Check-in</th><th>Llegada</th><th /></tr></thead>
          <tbody>
            {cargando && datos.length === 0 && <tr><td colSpan={6} className="empty">Cargando…</td></tr>}
            {!cargando && datos.length === 0 && <tr><td colSpan={6} className="empty">No hay alumnos con esos filtros.</td></tr>}
            {datos.map((a) => {
              const est = estadoCita(a);
              return (
                <tr key={a.id_user} className={a.llegado ? "llegado" : ""}>
                  <td className="ci-nombre" title={a.email}>{a.nombre}</td>
                  <td title={a.pisos_texto}>{a.pisos_texto || <span className="muted">—</span>}</td>
                  <td>{a.n_accesos > 0
                    ? <button className="btn btn-mini btn-entradas" onClick={() => setEntradas(a)}
                              title={`Última vez: ${fechaHoraES(a.ultimo_acceso)}. Pulsa para ver todas`}>{a.n_accesos}</button>
                    : <span className="badge badge-red" title="Todavía no ha entrado a la app">Nunca</span>}</td>
                  <td><span className={`badge ${est.clase}`}>{est.texto}</span>{a.cita_forzada ? <span className="badge badge-red" style={{ marginLeft: 6 }}>forzada</span> : null}</td>
                  <td>{a.llegado ? <span className="badge badge-green">✅ llegado</span> : <span className="muted">—</span>}</td>
                  <td><div className="acc-cell">
                    <button className="btn btn-mini btn-primary" disabled={a.llegado} onClick={() => setAsignar(a)} title={a.llegado ? "Ya ha llegado" : ""}>📅 {a.id_cita ? "Cambiar" : "Añadir"} cita</button>
                    {a.id_cita ? <button className="btn btn-mini" disabled={a.llegado} onClick={() => quitar(a)}>Quitar</button> : null}
                    <button className="btn btn-mini" onClick={() => setDetalle(a)}>🔍</button>
                  </div></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {asignar && <AsignarCita alumno={asignar} cerrar={() => setAsignar(null)} alGuardar={() => { setAsignar(null); refrescar(); }} />}
      {detalle && <Detalle alumno={detalle} cerrar={() => setDetalle(null)} />}
      {entradas && <EntradasModal usuario={{ id: entradas.id_user, nombre: entradas.nombre, email: entradas.email }} cerrar={() => setEntradas(null)} />}
    </div>
  );
}
